import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { EventSubscriptionToken } from '@sleed/bizcommerce-api';
import { eventSubscriptionsApi } from '~/lib/api/client';
import { formToToken, type EventSubscriptionFormValues } from '~/lib/schemas/event-subscription';

export const eventSubscriptionKeys = { all: ['event-subscriptions'] as const, list: () => [...eventSubscriptionKeys.all, 'list'] as const };

export function useEventSubscriptionsList() {
	return useQuery<EventSubscriptionToken[]>({
		queryKey: eventSubscriptionKeys.list(),
		queryFn: async () => (await eventSubscriptionsApi.getAll()).data.items ?? []
	});
}

export function useEventSubscriptionMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: eventSubscriptionKeys.list() });
	const update = useMutation({
		mutationFn: async (form: EventSubscriptionFormValues) => (await eventSubscriptionsApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await eventSubscriptionsApi.remove(id)).data, onSuccess: invalidate });
	return { update, remove };
}
